import React, { FunctionComponent } from "react";
import { $$, formatDate, useTranslate } from "../../helpers";
import { EstimatedMonthlyDrugCost } from "../../@types";
import { CollapsibleBox, MonthlyPlanPremiumDisclaimer } from "../../components";

interface EstimatedMonthlyCostsProps {
  monthlyCosts: EstimatedMonthlyDrugCost[];
  monthlyPremium: number;
}

const EstimatedMonthlyCosts: FunctionComponent<EstimatedMonthlyCostsProps> = ({
  monthlyCosts,
  monthlyPremium,
}) => {
  const t = useTranslate();

  return (
    <div className="ds-u-margin-top--4">
      <h3 className="ds-h3 ds-u-margin-top--2">
        {t("plan_details.drug_costs.estimated_monthly_drug_costs")}
      </h3>

      <MonthlyPlanPremiumDisclaimer premium={monthlyPremium} />

      <CollapsibleBox
        open={true}
        labelId="plan_details.drug_costs.view_monthly_drug_costs"
        titleClassname="ds-u-margin-bottom--2"
      >
        <table className="EstimatedMonthlyCosts__table">
          <thead>
            <tr>
              <th>{t("plan_details.drug_costs.time_period")}</th>
              <th>
                {t("plan_details.drug_costs.estimated_monthly_drug_costs")}
              </th>
            </tr>
          </thead>
          <tbody>
            {monthlyCosts.map((monthly, index) => {
              return (
                <tr key={index}>
                  <td>{monthly.date && formatDate(monthly.date, "MMMM")}</td>
                  <td>{$$(monthly.total)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CollapsibleBox>
    </div>
  );
};

export default EstimatedMonthlyCosts;
